import React, { useState } from 'react';
import { products } from '../data/products';
import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';
import Icon from '../components/Icon';

// Showcase carousel (reference style): visual on the left, name, text and feature chips on the right.
export default function Products() {
  const [i, setI] = useState(0);
  const n = products.length;
  const p = products[i];
  return (
    <section id="products" className="section">
      <div className="container">
        <SectionHeading row title="Our Products" text="Innovative software solutions built for modern businesses, crafted to simplify operations, boost efficiency and accelerate growth." />
        <Reveal className="showcase" key={p.name}>
          <div className="showcase__visual">
            <Icon name={p.icon} size={110} />
            <div className="showcase__tabs">
              {products.map((x, k) => (
                <button key={x.name} className={k === i ? 'is-on' : ''} aria-label={x.name} onClick={() => setI(k)} />
              ))}
            </div>
          </div>
          <div className="showcase__info">
            <h3>{p.name}</h3>
            <p>{p.text}</p>
            <ul className="chips">
              {p.features.map((f) => (<li key={f}><Icon name="check" size={16} />{f}</li>))}
            </ul>
            <div className="showcase__pager">
              <span>{i + 1}/{n}</span>
              <button aria-label="Previous product" onClick={() => setI((i + n - 1) % n)}><Icon name="arrow" size={16} className="flip" /></button>
              <button aria-label="Next product" onClick={() => setI((i + 1) % n)}><Icon name="arrow" size={16} /></button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
